import React from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useAuth } from '../../hooks/useAuth';
import { puedeVer } from '../../routes/permisos';
import './Navbar.css';

export const Navbar = () => {
  const { logout, roles } = useAuth();
  // El menu sale del mismo mapa que valida las rutas (routes/permisos.js), asi
  // no puede pasar que se vea un item que despues redirige.
  const ver = (ruta) => puedeVer(ruta, roles);

  const handleLogout = () => {
      // Limpia el token de sesión SAP y los datos del usuario, luego redirige.
      logout();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-codylsa">
      <div className="container-fluid">
        
        {/* LOGO */}
        <NavLink className="navbar-brand" to="/dashboard">
          <img 
            src="/logo_codylsa_white.svg" 
            alt="Grupo Codylsa" 
            className="logo-navbar" 
            style={{ height: '40px' }} 
          />
        </NavLink>

        {/* BOTÓN HAMBURGUESA (Móvil) */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* CONTENIDO DEL MENÚ */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            
            {/* 1. DASHBOARD */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/dashboard">
                <i className="bi bi-bar-chart-fill me-1"></i>
                Dashboard
              </NavLink>
            </li>

            {/* 2. COMPRAS (Dropdown corregido a <button>) */}
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle bg-transparent border-0"
                id="navbarDropdownCompras"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-cart4 me-1"></i>
                Compras
              </button>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownCompras">
                {ver('/compras/solicitudes') && (
                <li>
                    <NavLink className="dropdown-item" to="/compras/solicitudes">
                        Solicitudes de Compra
                    </NavLink>
                </li>
                )}
                {ver('/compras/ordenes') && (
                <li>
                    <NavLink className="dropdown-item" to="/compras/ordenes">
                        Órdenes de Compra
                    </NavLink>
                </li>
                )}
                <li><hr className="dropdown-divider" /></li>
                <li><h6 className="dropdown-header">Herramientas</h6></li>
                {ver('/compras/intercompany') && (
                <li>
                    <NavLink className="dropdown-item" to="/compras/intercompany">
                        <i className="bi bi-arrow-repeat me-2"></i>
                        Importador Intercompany
                    </NavLink>
                </li>
                )}
                {ver('/compras/centros-costo') && (
                <li>
                    <NavLink className="dropdown-item" to="/compras/centros-costo">
                        <i className="bi bi-diagram-3 me-2"></i>
                        Centros de Costo
                    </NavLink>
                </li>
                )}
                {ver('/consignacion') && (
                <li>
                    <NavLink className="dropdown-item" to="/consignacion">
                        <i className="bi bi-box-seam me-2"></i>
                        Stock en Consignación
                    </NavLink>
                </li>
                )}
              </ul>
            </li>

            {/* 3. ARTÍCULOS — oculto entero si el rol no ve ninguna de sus pantallas */}
            {(ver('/articulos') || ver('/articulos/importador') || ver('/articulos/actualizar')) && (
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle bg-transparent border-0"
                id="navbarDropdownArticulos"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-box-seam me-1"></i>
                Artículos
              </button>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownArticulos">
                {ver('/articulos') && (
                  <li><NavLink className="dropdown-item" to="/articulos">Control y Alta</NavLink></li>
                )}
                {ver('/articulos/importador') && (
                  <li><NavLink className="dropdown-item" to="/articulos/importador">Importador Masivo</NavLink></li>
                )}
                {ver('/articulos/actualizar') && (
                  <li>
                    <NavLink className="dropdown-item" to="/articulos/actualizar">
                      <i className="bi bi-pencil-square me-2"></i>
                      Actualización Masiva
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>

            )}

            {/* 4. INFORMES — idem */}
            {(ver('/informes/pendientes') || ver('/informes/reclamos') || ver('/informes/status')) && (
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle bg-transparent border-0"
                id="navbarDropdownInformes"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-clipboard-data me-1"></i>
                Informes
              </button>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownInformes">
                {ver('/informes/pendientes') && (
                <li>
                  <NavLink className="dropdown-item" to="/informes/pendientes">
                    <i className="bi bi-truck me-2 text-warning"></i>
                    Pendiente de Entrega
                  </NavLink>
                </li>
                )}
                {ver('/informes/reclamos') && (
                <li>
                  <NavLink className="dropdown-item" to="/informes/reclamos">
                    <i className="bi bi-table me-2 text-primary"></i>
                    Asistente Reclamos
                  </NavLink>
                </li>
                )}
                {ver('/informes/status') && (
                <li>
                  <NavLink className="dropdown-item" to="/informes/status">
                    <i className="bi bi-shield-check me-2 text-success"></i>
                    Status de Autorización
                  </NavLink>
                </li>
                )}
              </ul>
            </li>
            )}

            {ver('/notificaciones') && (
            <li className="nav-item">
              <NavLink className="nav-link" to="/notificaciones">
                <i className="bi bi-envelope-paper me-1"></i>
                Notificaciones
              </NavLink>
            </li>
            )}

          </ul>

          {/* LOGOUT */}
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <button className="nav-link btn btn-link text-white border-0 text-decoration-none" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right me-1"></i>
                Salir
              </button>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;